import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
} from "react-router-dom";
import Navbar from './components/Navbar';
import Home from './contents/Home';


function App() {
  return (
    <Router  basename={process.env.PUBLIC_URL}>
    <div className="App">
    <Navbar />
    <Route exact path="/">
    <Home/>
    </Route>
    </div>
    </Router>
    );
  }

  export default App;
